<template>
  <div class="modal counter-offer-modal">
    <div class="overlay" @click="$parent.closeCounterOfferModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img
              class="close"
              @click="$parent.closeCounterOfferModal"
              src="./../img/close.svg"
            />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="title dark">COUNTER OFFER</div>

                <div class="offer-items">
                  <div class="offer-items-header">
                    <span class="col-name">Item</span>
                    <span class="col-qty">Qty</span>
                  </div>
                  <div
                    class="offer-item-row"
                    v-for="(item, i) in $parent.counterOfferRequest.items"
                    :key="i"
                  >
                    <span class="col-name desc dark">{{ item.short_name }}</span>
                    <span class="col-qty desc dark">x{{ item.quantity }}</span>
                  </div>
                </div>

                <div class="offer-summary">
                  <div class="summary-row">
                    <span class="summary-label">Your price:</span>
                    <span class="summary-value your-price">
                      {{ $parent.counterOfferRequest.total_amount }}
                      <img src="./../img/coin.svg" class="coin-sm" />
                    </span>
                  </div>
                  <div class="summary-row highlight">
                    <span class="summary-label">Admin offer:</span>
                    <span class="summary-value offer">
                      {{ $parent.counterOfferRequest.counter_offer_amount }}
                      <img src="./../img/coin.svg" class="coin-sm" />
                    </span>
                  </div>
                </div>

                <div class="counter-offer-note desc dark">
                  By accepting, your items will be removed from the game and the offered amount will be credited to your payout balance.
                </div>

                <transition name="slide">
                  <div v-if="$parent.counterOfferError" class="error-desc desc red">
                    {{ $parent.counterOfferError }}
                  </div>
                </transition>

                <div class="counter-offer-buttons">
                  <button
                    class="button"
                    @click="$parent.approveCounterOffer"
                    :disabled="$parent.sellRequestActionLoading"
                  >
                    {{ $parent.sellRequestActionLoading ? 'PROCESSING...' : 'ACCEPT' }}
                  </button>
                  <button
                    class="button"
                    @click="$parent.declineCounterOffer($parent.counterOfferRequest.id)"
                    :disabled="$parent.sellRequestActionLoading"
                  >
                    DECLINE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CounterOfferModal",
};
</script>

<style scoped lang="scss">
.counter-offer-modal {
  .wrapper {
    max-width: 685px;
  }

  .container {
    padding: 52px 16px 0;
    max-height: 100vh;
    overflow: auto;
  }

  .form-fields-wrapper {
    text-align: center;
    max-width: 460px;
    margin: 0 auto;
    padding-bottom: 50px;
    font-family: "Inter", sans-serif;
    color: #312727;
  }

  .title {
    margin-bottom: 24px;
  }

  .offer-items {
    text-align: left;
    margin-bottom: 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    overflow: hidden;
  }

  .offer-items-header,
  .offer-item-row {
    display: flex;
    padding: 10px 16px;
    font-family: "Inter", sans-serif;
  }

  .offer-items-header {
    background: rgba(255, 255, 255, 0.05);
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.4);
    letter-spacing: 0.5px;
  }

  .offer-item-row {
    font-size: 14px;
    color: #312727;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
  }

  .col-name {
    flex: 1;
  }

  .col-qty {
    width: 60px;
    text-align: center;
  }

  .coin-sm {
    width: 14px;
    height: 14px;
    vertical-align: middle;
    position: relative;
    top: 1px;
  }

  .offer-summary {
    margin-bottom: 20px;
    text-align: left;
  }

  .summary-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    font-size: 15px;
  }

  .summary-row.highlight {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 12px;
    margin-top: 4px;
  }

  .summary-label {
    font-family: "Inter", sans-serif;
    color: rgba(49, 39, 39, 0.6);
    font-size: 15px;
    line-height: 24px;
  }

  .summary-value {
    font-family: "Inter", sans-serif;
    font-weight: 700;
    color: #312727;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 15px;
    line-height: 24px;
  }

  .summary-value.offer {
    color: #f56447;
    font-size: 16px;
  }

  .counter-offer-note {
    font-family: "Inter", sans-serif;
    font-size: 13px;
    color: rgba(49, 39, 39, 0.75);
    line-height: 1.5;
    margin-bottom: 20px;
  }

  .error-desc {
    margin-bottom: 16px;
    font-size: 14px;
    text-align: center;
    color: #ff5050 !important;
  }

  .counter-offer-buttons {
    display: flex;
    gap: 12px;

    .button {
      flex: 1;
      min-width: 0;
      margin-top: 0;
      font-size: 16px;
      line-height: 24px;
      text-transform: uppercase;
      border-radius: 15px;
    }
  }
}

@media screen and (max-width: 768px) {
  .counter-offer-modal .container {
    padding: 32px 16px;
  }

  .counter-offer-modal .counter-offer-buttons {
    flex-direction: column;
  }
}
</style>
